import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS } from '@angular/material/progress-spinner';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader, TranslateHttpLoaderConfig } from '@ngx-translate/http-loader';

import { authInterceptor } from './app-services/auth.interceptor';
import { formDataInterceptor } from './app-services/form-data.interceptor';
import { appRoutes } from './app.routes';

export const translateHttpLoaderConfig: Partial<TranslateHttpLoaderConfig> = {
  prefix: 'assets/i18n/',
  suffix: '.json',
  // Locale files are copied with stable names, so force a fresh request after each application reload.
  enforceLoading: true,
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(appRoutes),
    // Restores the DateAdapter that MatNativeDateModule provided before the standalone migration; MatDatepicker needs it.
    provideNativeDateAdapter(),
    // withXhr keeps upload progress events available for the model uploads;
    // the fetch backend cannot report upload progress.
    provideHttpClient(withInterceptors([authInterceptor, formDataInterceptor]), withXhr()),
    provideTranslateService({
      loader: provideTranslateHttpLoader(translateHttpLoaderConfig),
    }),
    { provide: MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS, useValue: { diameter: 30 } },
    // CDK 22 renders overlays with the Popover API, which puts every dialog in the
    // browser's top layer. Nothing with a z-index can draw over the top layer, so
    // Stripe's 3D Secure challenge (a body-level iframe at the maximum z-index)
    // ended up hidden behind the "pay by card" dialog. Keep overlays in the
    // z-index-based mode the app used before the upgrade.
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
  ],
};
